import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import { useEffect } from "react";
import { useIsDark } from "../stores/theme";
import { buildAntdTheme } from "./antd";

// Wraps AntD ConfigProvider với theme động theo store + system preference.
// Đồng bộ class CSS lên <body> để custom CSS dark mode hoạt động.
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const isDark = useIsDark();

  useEffect(() => {
    document.documentElement.dataset.theme = isDark ? "dark" : "light";
    document.documentElement.style.colorScheme = isDark ? "dark" : "light";
  }, [isDark]);

  return (
    <ConfigProvider theme={buildAntdTheme(isDark)} locale={viVN}>
      {children}
    </ConfigProvider>
  );
}
